import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  ElementRef,
  AfterViewChecked,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { AppHeaderComponent } from './header/header.component';
import { AppSidebarComponent } from './sidebar/sidebar.component';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class FullComponent implements OnDestroy,OnInit, AfterViewInit,AfterViewChecked {
  mobileQuery: MediaQueryList;

  @ViewChild('snav') sidenav: MatSidenav;
  

  private _mobileQueryListener: () => void;

  opcionesOficinaMecc = [
    { id: '13261502', descripcion: 'Las Heras' },
    { id: '13250100', descripcion: 'Luján' },
    { id: '13250200', descripcion: 'Maipú' },
    { id: '13261802', descripcion: 'Rodeo de la Cruz' },
    { id: '13240800', descripcion: 'Uspallata' },
    { id: '13100000', descripcion: 'Mecc' }
  ]

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
show_credits()
{
  //alert("Mesa de Entradas de Documentos")

}

  mostrarBotonMecc(): boolean {
    return localStorage.getItem('esMecc') === 'true'
  }

  elegirOficinaMecc(opcion) {
    const data = JSON.parse(localStorage.getItem('meta4_user_data'))
    if (!data || typeof data !== 'object') {
      return
    }
    if (!data['cod_nomenclador'] && data['id'] === '13100000') {
      data['cod_nomenclador'] = '012144'
    }
    data['id'] = opcion.id
    if (opcion.id === '13100000') {
      delete data['descripcion_mecc']
    } else {
      data['descripcion_mecc'] = opcion.descripcion
    }
    localStorage.setItem('meta4_user_data', JSON.stringify(data))
  }
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngAfterViewInit() {
    setTimeout(() => { this.sidenav.close()})
  }
  ngOnInit()
  {
    //this.sidenav.close()
  }

  ngAfterViewChecked(){}
}
